"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _VerifyEmailComponent = _interopRequireDefault(require("./VerifyEmailComponent"));
var _verifyEmailActions = require("../../redux/actions/verifyEmailActions");
var _queryParamsHelper = require("../../helpers/queryParamsHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var processingVerifyEmail = state.apiProcessing.processingVerifyEmail,
    _state$verifyEmail = state.verifyEmail,
    message = _state$verifyEmail.message,
    error = _state$verifyEmail.error;
  return {
    processingVerifyEmail: processingVerifyEmail,
    message: message,
    error: error
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  var d1 = (0, _queryParamsHelper.getQueryParam)('d1');
  var userid = (0, _queryParamsHelper.getQueryParam)('UserId');
  var verifycode = (0, _queryParamsHelper.getQueryParam)('verifycode');
  return {
    fetchConfirmEmail: function fetchConfirmEmail() {
      return dispatch((0, _verifyEmailActions.fetchConfirmEmail)({
        verifycode: verifycode,
        userid: userid,
        d1: d1
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_VerifyEmailComponent["default"]);